<template>
  <div class="sidenav-container" :class="{ active: show }">
    <div class="top-icon-box">
      <img
        src="@/assets/img/logo.png"
        @click="openMenu()"
        class="logo"
        alt="nkr-sync-logo"
      />
      <div class="logo-text">
        NKR Sync
        <br />
        All Together - s3 - 0
      </div>
      <div class="close-menu">
        <img
          src="@/assets/icons/close-menu.svg"
          class="close-menu"
          alt="close-menu"
          @click="closeMenu()"
        />
      </div>
    </div>
    <ul class="nav-list">
      <li
        v-for="(item, index) in menuUpdated"
        :key="index"
        class="nav-item"
        v-show="hasPermission(item)"
      >
        <router-link
          :to="{ name: item.pageName, params: item.params || {} }"
          :alt="item.displayText"
        >
          <div class="icon-box-nav">
            <baseTooltip :text="item.displayText" :disabled="show">
              <img :src="`${publicPath}${item.icon}`" :alt="item.displayText" />
            </baseTooltip>
          </div>
          <div class="menu-item-text">
            {{ item.displayText }}
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { getMenu } from "@/api/GeneralData.js";

export default {
  name: "LeftBar",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      menuItems: [],
      publicPath: process.env.VUE_APP_IMG_BASE_URL
    };
  },
  async mounted() {
    this.menuItems = await getMenu();
  },
  computed: {
    menuUpdated() {
      const departmentWarehouse = this.departamentos.map(department => ({
        displayText: department.nombre,
        icon: "api/menu-icons/ecommerce.svg",
        pageName: "OrdersPageWarehouse",
        params: {
          departmentCode: department.codigo
        },
        role: ["superAdmin"],
        specialPermission: `can_see_orders_${department.codigo.toLowerCase()}`
      }));
      // add to new menuItems in position 2 and return
      const menuItems = [...this.menuItems];
      menuItems.splice(2, 0, ...departmentWarehouse);
      menuItems.push({
        displayText: "Recepciones",
        icon: "api/menu-icons/warehouse.svg",
        pageName: "ReceptionsPage"
      });
      this.departamentos.forEach(department => {
        menuItems.push({
          displayText: `Delivery ${department.codigo}`,
          icon: "api/menu-icons/shipments.svg",
          pageName: "DeliveryTripsPage",
          params: { departmentCode: department.codigo },
          specialPermission: `can_see_orders_${department.codigo.toLowerCase()}`
        });
        console.log(
          "Added delivery menu item for department:",
          department.codigo,
          `can_see_orders_${department.codigo.toLowerCase()}`
        );
      });
      return menuItems;
    },
    departamentos() {
      return this.$store.getters["general/getDepartments"];
    },
    navCategories() {
      return this.$store.getters["general/navCategories"];
    }
  },
  beforeDestroy() {
    this.closeMenu();
  },
  methods: {
    hasPermission(item) {
      // If no special permission required, show the item
      if (!item.specialPermission && (!item.roles || item.roles.length === 0)) {
        return true;
      }
      // If user has superAdmin role, show all items
      const userRoles = this.$store.getters["auth/getUserRoles"] || [];
      if (userRoles.includes("superAdmin")) {
        return true;
      }

      // Check if user has required special permission
      if (item.specialPermission) {
        const userPermissions =
          this.$store.getters["auth/getUserPermissions"] || [];
        return userPermissions.includes(item.specialPermission);
      }

      return false;
    },
    closeMenuAndGoTo(route) {
      this.closeMenu();
      this.$router.push(route);
    },
    closeMenu() {
      this.$emit("close");
    },
    openMenu() {
      this.$emit("open");
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/style/css/generic-variables.scss";
$logoWidth: 40px;
.sidenav-container {
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.35);
  width: 45px;
  height: auto;
  background-color: $sidenavBackground;
  width: 65px;
  overflow: hidden;
  z-index: 1;
  .top-icon-box {
    height: $headerHeight;
    padding: 0px 15px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    color: $mainTextColor;
    background-color: $sidenavBackground2;
    img {
      width: 100%;
    }
  }
  ul.nav-list {
    padding: 0px;
    li.nav-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 48px;
      a {
        width: 100%;
        display: flex;
        justify-content: center;
        .icon-box-nav {
          width: 30px;
          height: 100%;
          display: inline-flex;
          align-items: center;
          margin: 0 auto;
          img {
            width: 100%;
            margin-right: 15px;
          }
        }
        .menu-item-text {
          height: 100%;
          display: none;
          align-items: center;
        }
      }
      a:hover {
        background-color: $sidenavLinkHover;
      }
    }
  }
  .menu-item-text {
    display: none;
  }
  .logo-text,
  .close-menu {
    display: none;
  }
  &.active {
    width: 265px;
    .top-icon-box {
      display: flex;
      flex-direction: row;
      position: relative;
      img {
        width: $logoWidth;
      }
      .logo-text {
        margin-left: 15px;
        display: block;
      }
      .close-menu {
        display: block;
        position: absolute;
        right: 5px;
        top: 5px;
        width: 30px;
      }
    }
    ul.nav-list {
      li.nav-item {
        a {
          width: 100%;
          padding: 0px 20px;
          height: 100%;
          color: $sidenavLink;
          vertical-align: middle;
          display: grid;
          grid-template-columns: 30px 1fr;
          grid-column-gap: 15px;
          color: $mainTextColor;
          .icon-box-nav {
            width: 30px;
            height: 100%;
            display: inline-flex;
            align-items: center;
            img {
              width: 100%;
              margin-right: 15px;
            }
          }
          .menu-item-text {
            display: inline-flex;
          }
        }
      }
    }
  }
}
.router-link-active {
  border: 2px solid #00000040;
  background-color: #f1f1f1;
}
</style>
